export default "__VITE_ASSET__Bm43CblF__"